var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeakicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.75,
    fill: "#F1935C",
    stroke: "#F1935C",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6757_10070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69409 10.42H8.81138C9.26295 10.42 9.63242 10.7895 9.63242 11.2411V15.3463C9.63242 15.7979 9.26295 16.1673 8.81138 16.1673H8.69409C8.24252 16.1673 7.87305 15.7979 7.87305 15.3463V11.2411C7.87305 10.7895 8.24252 10.42 8.69409 10.42ZM11.9783 7.95691C12.4298 7.95691 12.7993 8.32638 12.7993 8.77795V15.3463C12.7993 15.7979 12.4298 16.1673 11.9783 16.1673C11.5267 16.1673 11.1572 15.7979 11.1572 15.3463V8.77795C11.1572 8.32638 11.5267 7.95691 11.9783 7.95691ZM15.2624 12.6486C15.714 12.6486 16.0835 13.018 16.0835 13.4696V15.3463C16.0835 15.7979 15.714 16.1673 15.2624 16.1673C14.8108 16.1673 14.4414 15.7979 14.4414 15.3463V13.4696C14.4414 13.018 14.8108 12.6486 15.2624 12.6486Z",
    fill: "#F9FBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6757_10070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.075,
    height: 14.075,
    fill: "white",
    transform: "translate(4.94043 5.02466)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakicon);
export default __webpack_public_path__ + "static/media/peakicon.a8dfb93a65a285203bbea6c426a1e875.svg";
export { ForwardRef as ReactComponent };